import {
  ref,
  reactive,
  computed,
  onBeforeMount,
  watch,
} from "@vue/composition-api";
import router from "@/router";

export default function useQuizInfo() {
  const modeEditor = ref(true);
  const stepActive = ref(0);
  const quizId = ref(0);

  const formData = reactive({
    titleName: "",
    isHaspermission: false
  });

  const scrollToTop = () => {
    const rootEle = document.documentElement;
    rootEle.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const onNextStep = (data) => {
    stepActive.value = stepActive.value++;
  };

  const onPreviousStep = () => {
    stepActive.value = stepActive.value--;
  };

  const checkCreateOrEdit = () => {
    if (router.currentRoute.params.ref) {
      modeEditor.value = false;
      quizId.value = parseInt(router.currentRoute.params.ref);
    }
  };

  const onSetTitleName = (title) => {
    formData.titleName = title;
  };

  const isHaspermission = (permission) => {
    formData.isHaspermission = permission
  };

  onBeforeMount(() => {
    if (localStorage.getItem("activeTab") !== null) {
      stepActive.value = parseInt(localStorage.getItem("activeTab"));
    } else {
      localStorage.setItem("activeTab", stepActive.value);
    }

    checkCreateOrEdit();
  });

  watch(
    stepActive,
    () => {
      localStorage.setItem("activeTab", stepActive.value);
    },
    { deep: true }
  );

  return {
    modeEditor,
    stepActive,
    quizId,
    scrollToTop,
    onNextStep,
    onPreviousStep,
    formData,
    onSetTitleName,
    isHaspermission
  };
}
